module.exports = __webpack_public_path__ + "static/fs-1-7cdec50e873c5e8a5b772b581dae4f03.jpg";